export default "__VITE_ASSET__CX3P2t1p__"